const START_AJAX_CALL = 'START_AJAX_CALL';
const END_AJAX_CALL = 'END_AJAX_CALL';
const RESET_AJAX_STATUS = 'RESET_AJAX_STATUS';
const SET_AJAX_STATUS = 'SET_AJAX_STATUS';
const UPDATE_AJAX_STATUS = 'UPDATE_AJAX_STATUS';
const SET_ACTION_STATUS = 'GET_ACTION_STATUS';

const initialState = {
  isLoading: false,
  error: null,
  showSpinner: true, //show spinner while loading
  showSuccessAlert: false,
  isEditAction: false,
};

export const ajaxActions = {
  sendAjaxRequest: (
    requestUrl,
    method,
    successCallback,
    body = null,
    showSpinner = true
  ) => async (dispatch, getState) => {
    dispatch({ type: START_AJAX_CALL, showSpinner: showSpinner });
    const { auth } = getState();
    const requestParams = {
      method: method,
      headers: {
        Authorization: 'Bearer ' + auth.accessToken,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: body,
    };
    const response = await fetch(requestUrl, requestParams);
    if (!response.ok) {
      const errorResult = await response.json();
      dispatch({
        type: END_AJAX_CALL,
        error: {
          status: response.status,
          statusText: errorResult.errorText,
          validationErrors: errorResult.validationErrors,
        },
      });
      return;
    }
    const result = await response.json();
    dispatch({ type: END_AJAX_CALL });
    successCallback(result);
  },

  sendAjaxPdfRequest: (
    requestUrl,
    method,
    successCallback,
    body = null,
    showSpinner = true
  ) => async (dispatch, getState) => {
    dispatch({ type: START_AJAX_CALL, showSpinner: showSpinner });
    const { auth } = getState();
    const requestParams = {
      method: method,
      headers: {
        Authorization: 'Bearer ' + auth.accessToken,
        'Content-Type': 'application/json',
        Accept: 'application/pdf',
      },
      body: body,
    };
    const response = await fetch(requestUrl, requestParams);
    if (!response.ok) {
      const errorResult = await response.json();
      dispatch({
        type: END_AJAX_CALL,
        error: {
          status: response.status,
          statusText: errorResult.errorText,
          validationErrors: errorResult.validationErrors,
        },
      });
      return;
    }
    const result = await response.blob();
    dispatch({ type: END_AJAX_CALL });
    successCallback(result);
  },

  setAjaxStatus: (isLoading) => {
    return { type: SET_AJAX_STATUS, isLoading };
  },

  resetAjaxStatus: () => {
    return { type: RESET_AJAX_STATUS };
  },

  updateAjaxStatus: () => {
    return { type: UPDATE_AJAX_STATUS };
  },

  setActionStatus: (isEditAction) => {
    return { type: SET_ACTION_STATUS, isEditAction };
  },
};

export const reducer = (state, action) => {
  state = state || initialState;

  if (action.type === START_AJAX_CALL) {
    return {
      ...state,
      isLoading: true,
      showSpinner: action.showSpinner,
    };
  }

  if (action.type === END_AJAX_CALL) {
    return {
      ...state,
      isLoading: false,
      error: action.error,
    };
  }

  if (action.type === RESET_AJAX_STATUS) {
    return {
      ...state,
      isLoading: false,
      error: null,
      showSuccessAlert: false,
    };
  }

  if (action.type === SET_AJAX_STATUS) {
    return {
      ...state,
      isLoading: action.isLoading,
      showSpinner: action.isLoading,
    };
  }
  if (action.type === UPDATE_AJAX_STATUS) {
    return {
      ...state,
      showSuccessAlert: true,
    };
  }
  if (action.type === SET_ACTION_STATUS) {
    return {
      ...state,
      isEditAction: action.isEditAction,
    };
  }
  return state;
};
